import React from 'react'

const PaymentsMade = () => {
  return (
    <div>PaymentsMade</div>
  )
}

export default PaymentsMade